import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import splash from "../../Assets/Projects/splash.jpg";
import quizapp from "../../Assets/Projects/quiz.png";
import chatapp from "../../Assets/Projects/aichatbot.png";
import fasholapp from "../../Assets/Projects/Fashion-Ecommerce-app.png";
import trading from "../../Assets/Projects/trading.png";
import eco from "../../Assets/Projects/eco.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fasholapp}
isBlog={false}
title="Fashion E-commerce App"
description="A modern fashion e-commerce mobile application built using Flutter. The app features a clean and responsive UI, product listings, category filters, detailed product pages, shopping cart, and a smooth checkout flow. It’s designed for both Android and iOS platforms and supports Firebase backend for authentication and real-time updates."
ghLink="https://github.com/AndroidWithJoyonta/Fashion-Ecommerce-app"
demoLink="#"

            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
             imgPath={eco}
isBlog={false}
title="E-commerce App"
description="A full-featured eCommerce mobile application developed with Flutter. The app includes a beautiful user interface, product listing with search and filters, product detail view, shopping cart, order history, and secure user authentication. Integrated with Firebase for backend services like authentication and real-time database support."
ghLink="https://github.com/AndroidWithJoyonta/resturantApp"
demoLink="#"

            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
             imgPath={chatapp}
isBlog={false}
title="AI Chat Bot"
description="An AI-powered chatbot application built with Flutter (or React.js), designed for real-time conversations. It supports natural language interaction, maintains chat history, and features a clean, intuitive UI. Integrated with OpenAI API (or Dialogflow) for intelligent responses. Useful for customer support, FAQs, and general-purpose AI chat."
ghLink="https://github.com/AndroidWithJoyonta/Ai-Chat-Bot-App-Flutter"
demoLink="#"
            
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
            imgPath={splash}
isBlog={false}
title="E-commerce App"
description="A visually engaging and feature-rich E-commerce mobile app built using Flutter. The app includes product categories, detailed product pages, shopping cart, user login & registration, and a complete checkout process. It’s integrated with Firebase for authentication and real-time database, ensuring seamless performance across Android and iOS platforms."
ghLink="#"
demoLink="#"

            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
             imgPath={trading}
isBlog={false}
title="Trading App"
description="A sleek and real-time trading application developed using Flutter. It allows users to track live market prices, view historical charts, manage portfolios, and perform mock trades. The app integrates with financial APIs for real-time stock data and supports watchlists, filters, and basic analytics to assist users in making informed investment decisions."
ghLink="#"
demoLink="#"

            
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
            imgPath={quizapp}
isBlog={false}
title="Quiz App"
description="A responsive and user-friendly Quiz App developed using Flutter. It includes multiple quiz categories such as Math, Science, History, and General Knowledge. The app features a dynamic question set, timer-based quizzes, scoring system, and result analysis. Integrated with a local database for offline support and customizable quiz levels."
ghLink="#"
demoLink="#"

            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
